export const getInsightsDiffPct = (currMetric: number, prevMetric: number): string => {
    if (prevMetric === 0) {
        return "";
    }

    const result = ((100 * (currMetric - prevMetric)) / prevMetric).toFixed(1);

    return result.toString();
};

export const getInsightsDiffPctCurried =
    (prevMetric: number) =>
    (currMetric: number): string =>
        getInsightsDiffPct(currMetric, prevMetric);
